module.exports = __webpack_public_path__ + "static/media/SE_child_reading.bea1101d.mp4";